module.exports = __webpack_public_path__ + "28d27de7fd699160b64658bca09397b2.png";